import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';
import { ApiService } from 'src/app/service/apiServices';
declare var jquery: any;
declare var $: any;
import Swal from 'sweetalert2';
import { Global } from '../../../global';
import { AuthService } from '../../../service/auth/auth.service'

@Component({
  selector: 'app-play-lists',
  templateUrl: './play-lists.component.html',
  styleUrls: ['./play-lists.component.css']
})
export class PlayListsComponent implements OnInit {

  estab: any = {};
  listPlayLists: any = [];
  filtro: string = "";
  pagina: any = 1;
  totalPorPagina: any = 10;
  totalPagina: any = 1;
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private alerts: NgxAlertsService,
    private router: Router,
    private global: Global,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.getlistPlayLists();
  }

  saveUser = (estab) => {
  }


  confirmationAtivarDesativar = (id, ativo) => {
    Swal.fire({
      title: 'Atenção',
      text: `Tem certeza que deseja ${ativo ? "ativar" : "desativar"} esse Playlist?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#dc3545'
    }).then(
      result => {
        if (result.isConfirmed) {
          Swal.fire('Favor aguarde');
          Swal.showLoading();
          this.service.AtivarDesativar(`Playlist/${id}/Ativar`, ativo).then((res) => {
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Sucesso!',
              html: 'Operação realizada com sucesso!'
            }).then(
              result => {
                if (result.isConfirmed) {
                  this.getlistPlayLists();
                }
              }
            );
          }).catch((err) => {
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              html: err.error.erros[0].messagem
            });
          })
        }
      }
    );
  }

  emitError = (error) => {
    if (typeof error == 'string') {
      Swal.fire('Erro', `${error}`, 'error');
      return
    }
    if (error.status == 401 || error.error.status == 401) {
      Swal.close()
      this.authService.logoutUser()
    }
    if (error.status === 404) {
      Swal.fire('Atenção', `${error.error}`, 'warning');
      return
    }
    if (error.status) {
      Swal.fire({ icon: 'error', title: 'Erro', html: `${error.status} - ${error.error.erros[0].messagem}` })
      return
    }
    if (error.alert) {
      Swal.fire('Atenção', `${error.txt}`, 'warning');
      return
    }
  }

  emitAlert = () => {
    Swal.close()
    this.alerts.notifyError({
      body: `Erro`,
      title: 'Erro'
    });
  }

  filtroLista() {
    if (this.listPlayLists.length === 0) {
      return this.listPlayLists;
    }
    return this.listPlayLists.filter(
      e => e.nome.toLocaleLowerCase().includes(this.filtro.toLocaleLowerCase()) ||
        e.cnes.includes(this.filtro) ||
        e.cnpj.replace(".", "").replace(".", "").replace("/", "").replace("-", "").includes(this.filtro.replace(".", "").replace(".", "").replace("/", "").replace("-", ""))
    );
  }


  resultBuscaPlaylist = (result) => {
    if (result != null) {
      this.listPlayLists = result['conteudo'];
      if (this.listPlayLists.length > 0) {
        this.totalPagina = Math.ceil(result['quantidade_total'] / this.totalPorPagina)
      }
    }
    else {
      this.pagina = 1;
      this.service.Get(`Playlist?pagina=${this.pagina}&quantidade=${this.totalPorPagina}`).then(res => {
        this.listPlayLists = res['conteudo'];
        if (this.listPlayLists.length > 0) {
          this.totalPagina = Math.ceil(res['quantidade_total'] / this.totalPorPagina)
        }

        Swal.close();
        this.loading = false;
      }).catch(res => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close()
          this.authService.logoutUser()
        }
        Swal.close();
        this.loading = false;
        Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
      });
    }
  }

  voltarPagina = () => {
    this.pagina = this.pagina - 1;
    this.getlistPlayLists();
  }

  getlistPlayLists = () => {
    Swal.fire({
      title: 'Favor aguarde',
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    Swal.showLoading();

    var url = `Playlist?pagina=${this.pagina}&quantidade=${this.totalPorPagina}`;

    if (this.filtro) {
      url = url + `&nome=${this.filtro}`;
    }

    this.service.Get(url).then(res => {
      this.listPlayLists = res['conteudo'];
      if (this.listPlayLists.length > 0) {
        this.totalPagina = Math.ceil(res['quantidade_total'] / this.totalPorPagina)
      }
      Swal.close();
      this.loading = false;
    }).catch(res => {
      if (res.status == 401 || res.error.status == 401) {
        Swal.close()
        this.authService.logoutUser()
      }
      Swal.close();
      this.loading = false;
      Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
    });
  }

  obterListaFiltros() {
    this.pagina = 1;
    this.getlistPlayLists();
  }
}
